import React from 'react';
import styles from './App.module.css';
import EventsList from '../components/EventsList/EventsList';

function App() {
  const sampleEvents = [
    {
      id: 1,
      title: 'ICE Watch',
      type: 'mutual_aid',
      date: 'Jan, 31st, 3:00 PM',
      description: 'Community Defense Training, Community Organizing Session',
      location_1: 'MAIN AUDITORIUM, Weber County Library Ogden Branch',
      location_2: '2464 Jefferson Avenue, Ogden, UT, 84401'
    },
    {
      id: 2,
      title: 'ICE OUT MASS GATHERING',
      type: 'protest',
      date: 'Jan, 31st, 12 PM',
      description: 'Peacefull Mass Gathering',
      location_1: '2549 S WASHINTON BLVD',
      location_2: 'Ogden'
    }
  ];

  return (
    <div className={styles.App}>
      <header className={styles.header}>
        <h1>Community Actions</h1>
      </header>
      <EventsList events={sampleEvents} />
    </div>
  );
}

export default App;
